import { Component, OnInit, Inject } from "@angular/core";
import { IFormAgeOfMajority18 } from "../../../../Models/Forms/IFormAgeOfMajority18";
import { FormAgeOfMajority18Service } from "../../../../Services/FormAgeOfMajority18Service";
import { Globals } from '../../../../globals';
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IepService } from "../../../../Services/IepService";
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { IReportParameter } from "src/app/Models/IReportParameter";
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from "src/app/Services/ReportService";

@Component({
  selector: 'AgeOfMajority18',
  templateUrl: './AgeOfMajority18.component.html',
  styleUrls: ['./AgeOfMajority18.component.css']
})

export class FormAgeOfMajority18Component extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  private _baseUrl: string;
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  isLocked: boolean;
  lockStatus: string;  
  canEditIep: boolean;
  saveClicked: boolean;
  formAgeMajority18FromDB: any = [];
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;

  constructor(
    private globals: Globals,
    private _frmAgeMajority18Service: FormAgeOfMajority18Service,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string, reportService: ReportService) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }

  ngOnInit(): void {
    this.LoadFormAge18MajorityFormDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock() {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=UnLock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  LoadFormAge18MajorityFormDetails(): void {
    this._frmAgeMajority18Service.getFormAgeOfMajority18(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormAgeOfMajority18) => {
        this.formAgeMajority18FromDB = res
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the Vision Hearing
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._frmAgeMajority18Service.insertUpdateFormAgeOfMajority18(this.formAgeMajority18FromDB)
      .subscribe((res: IFormAgeOfMajority18) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock();          
        }
        this.saveClicked = false;
        this.validateForm();
        this.LoadFormAge18MajorityFormDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._frmAgeMajority18Service.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock();
    this.LoadFormAge18MajorityFormDetails();
  }
   
  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formAgeMajority18FromDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.formAgeMajority18FromDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: this.selectedIepInstance.statusName == 'Draft' ? 'Draft Draft Draft' : '' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: this.formAgeMajority18FromDB.iepId.toString() }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formAgeMajority18FromDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formAgeMajority18FromDB.rdlFileNameSpanish, this.reportParamArray);
  }

}


